//@flow

import React from 'react';

type Props = {
  options: Array<string>,
  onChange: () => void,
  value: string,
};

export default function Picker({ value, onChange, options }: Props) {
  return (
    <div className="service-dp">
      <select onChange={e => onChange(e.target.value)} value={value}>
        {options.map(option => (
          <option value={option} key={option}>
            {option.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Trek/ServiceModal/Picker.js